module.exports = __webpack_public_path__ + "1885a7328d070cff0d774edd8605ec16.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/destructive_abilities-768.jpg
// module id = 254
// module chunks = 0